"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMenuItemsFilter = void 0;
const UPGRADE_TO_CONSULTANT_KEY = 'become-consultant';
const UPGRADE_TO_BRAND_PARTNER_KEY = 'upgrade-to-brand-partner';
const CUSTOMER_TYPE_ID_MEMBER = 11;
const filterMenuItems = (items, isDesktop, customerTypeId) => isDesktop || customerTypeId === CUSTOMER_TYPE_ID_MEMBER ? items : items.filter(x => !x.url?.includes(UPGRADE_TO_CONSULTANT_KEY) && !x.url?.includes(UPGRADE_TO_BRAND_PARTNER_KEY));
const findUrl = (menuItems, key) => menuItems.find(x => x.url?.includes(key))?.url ?? '';
const useMenuItemsFilter = (items, isDesktop, customerTypeId) => ({
  filteredItems: filterMenuItems(items, isDesktop, customerTypeId),
  upgradeToConsultantUrl: findUrl(items, UPGRADE_TO_CONSULTANT_KEY),
  upgradeToBrandPartnerUrl: findUrl(items, UPGRADE_TO_BRAND_PARTNER_KEY)
});
exports.useMenuItemsFilter = useMenuItemsFilter;
